module.exports = __webpack_public_path__ + "static/media/11.241f9901.jpg";